import { initContentSlider } from "./content-slider.js";

const TESTIMONIAL_SLIDER_SELECTOR = ".testimonial-slider__swiper";

export const testimonialSlider = () => {
  initContentSlider({
    swiperSelector: TESTIMONIAL_SLIDER_SELECTOR,
    sectionClass: "testimonial-slider",
    navPrevClass: "testimonial-slider__nav--prev",
    navNextClass: "testimonial-slider__nav--next",
    slidesPerView: 1,
    loop: true,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 24 },
    },
  });
};
